import React, { useEffect } from 'react'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

import PDFViewer from 'components/common/PDFViewer'
import Modal from 'components/common/Modal'
import Async from 'components/common/Async'
import { useLibraryPreview } from 'hooks/library'

function ContentPreview({ content, contentType = '', fileName }) {
  let contentComponent = content?.toString()

  if (contentType?.toLowerCase().includes('pdf'))
    contentComponent = <PDFViewer url={content} fileName={fileName} />

  if (contentType.includes('tiff')) {
    return <Box>No preview available.</Box>
  }

  if (contentType.includes('text') && content instanceof Blob) {
    contentComponent = <Async observable={content.text()} />
  }

  if (contentType.includes('image')) {
    contentComponent = <img src={URL.createObjectURL(content)} alt="" />
  }

  if (!content) return <Box />

  return (
    <Box
      sx={{
        overflow: 'auto',
        width: '100%',
        height: '70vh',
      }}
    >
      {contentComponent}
    </Box>
  )
}

function PreviewModal({ open, setOpen, libraryItem }) {
  const { preview, refetch, loading } = useLibraryPreview({
    libraryItem,
    version: libraryItem?.version,
  })

  const handleClose = () => {
    setOpen(null)
  }

  useEffect(() => {
    if (libraryItem && open) refetch()
  }, [libraryItem, open])

  return (
    <Modal
      title="Preview"
      open={open}
      onClose={handleClose}
      width="60vw"
      footerButtonProps={[
        {
          children: 'Close',
          variant: 'contained',
          color: 'primary',
          onClick: handleClose,
        },
      ]}
    >
      <Box sx={{ display: 'flex' }}>
        {loading && <CircularProgress sx={{ mx: 'auto' }} />}
        {!loading && preview && (
          <ContentPreview
            content={preview}
            fileName={libraryItem?._embedded?.document?.filename}
            contentType={libraryItem?.mime_type}
          />
        )}
      </Box>
    </Modal>
  )
}

export default PreviewModal
